import { useState, useEffect} from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../Common/http-common.js";
import * as common from "../../Common/common.js";
import * as Comp from "../../Common/CommonComponents.js";
import { GetPageAuthorityFn } from "../../Common/authority.js";
import CssClass from "../../Styles/common.module.css";
import ConfirmModal from '../../Components/BasicElements/ConfirmModal.js';
import AllowanceDetailsUpdate from '../../Components/History/Allowance/AllowanceDetailsUpdate';
import AllowanceDetailsDelete from '../../Components/History/Allowance/AllowanceDetailsDelete';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tag } from 'primereact/tag';
import { faSquarePlus, faFileImport, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const PAGE_NAME = "Allowance.js_";
const MODULE_ID = "WEB_AP_002";

const Allowance = (props) => {
	const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [userName] = useState(cookies.USERNAME);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
	const [allowanceId, setAllowanceId] = useState("");
	const [userDept, setUserDept] = useState([]);
	const [holidayList, setHolidayList] = useState([]);
	const [dayTypeList, setDayTypeList] = useState([]);
  const [dayType, setDayType] = useState([]);
	const [workLocationList, setWorkLocationList] = useState([]);
  const [workLocation, setWorkLocation] = useState([]);
  const [allowanceTypeList, setAllowanceTypeList] = useState([]);
  const [allowanceType, setAllowanceType] = useState([]);
  const [timeRange, setTimeRange] = useState([null, null]);
  const [startTime, endTime] = timeRange;
  const [amount, setAmount] = useState([]);
  const [isFixedTime, setIsFixedTime] = useState(false);
  const [totalHour, setTotalHour] = useState([]);
  const [editData, setEditData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
  const [inputError, setInputError] = useState([]);
  const [allData, setAllData] = useState([]);
  const initialEditData = {
    PURPOSE: "",
    DETAILS: ""
  };

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });
  
  // Calculate total amount from allData
  const totalAmount = allData?.reduce((sum, row) => {
    const value = parseFloat(row.AMOUNT) || 0;
    return sum + value;
  }, 0);

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  // #region useEffect
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get User Dept";
      setLoading(true);
      setLoadingText("Getting User Dept, please wait...");
  
      http
        .get("api/allowance/GetUserDept?_sysUser=" + userId, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].DEPT_ID,
              value: response.data[i].DEPT_NAME,
              label: response.data[i].DEPT_NAME,
            });
          }
          setUserDept(listItems[0]);
        })
        .catch((err) => {
          toast.error("Error on getting user dept. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting user dept. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId]);

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get Holiday List";
      setLoading(true);
      setLoadingText("Getting Holiday List, please wait...");

      http
        .get("api/allowance/GetHolidayList?_sysUser=" + userId, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].HOLIDAY_ID,
              value: response.data[i].HOLIDAY_DATE,
              label: response.data[i].HOLIDAY_NAME,
            });
          }
          setHolidayList(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting holiday list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting holiday list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId]);

  useEffect(() => {
    let functionName = "";

    if (!userDept.key) return;

    try {
      functionName = "Get Day Type List";
      setLoading(true);
      setLoadingText("Getting Day Type List, please wait...");
  
      const deptId = userDept.key;

      http
        .get("api/allowance/GetDayTypeList?_sysUser=" + userId +
          "&_deptId=" +
          deptId, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].DAY_TYPE_ID,
              value: response.data[i].DAY_TYPE_ID,
              label: response.data[i].DAY_TYPE,
            });
          }
          setDayTypeList(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting day type list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting day type list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId, userDept]);

  useEffect(() => {
    let functionName = "";

    if (!userDept.key || !dayType.key) return;

    try {
      functionName = "Get Work Location List";
      setLoading(true);
      setLoadingText("Getting Work Location List, please wait...");
  
      const deptId = userDept.key;
      const dayTypeId = dayType.key;
  
      http
        .get("api/allowance/GetWorkLocationList?_sysUser=" + userId +
          "&_deptId=" +
          deptId +
          "&_dayType=" +
          dayTypeId, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].WORK_LOCATION_ID,
              value: response.data[i].WORK_LOCATION_ID,
              label: response.data[i].WORK_LOCATION,
            });
          }
          setWorkLocationList(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting work location list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting work location list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId, userDept, dayType]);
  
  useEffect(() => {
    let functionName = "";

    if (!userDept.key || !dayType.key || !workLocation.key) return;
    
    try {
      functionName = "Get Allowance Type List";
      setLoading(true);
      setLoadingText("Getting Allowance Type List, please wait...");
  
      const deptId = userDept.key;
      const dayTypeId = dayType.key;
      const workLocationId = workLocation.key;
  
      http
        .get("api/allowance/GetAllowanceTypeList?_sysUser=" + userId +
          "&_deptId=" +
          deptId +
          "&_dayType=" +
          dayTypeId +
          "&_workLocation=" +
          workLocationId, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].ALLOWANCE_TYPE_ID,
              value: response.data[i].ALLOWANCE_TYPE_ID,
              label: response.data[i].ALLOWANCE_TYPE,
            });
          }
          setAllowanceTypeList(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting allowance type list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting allowance type list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId, userDept, dayType, workLocation]);
  
  useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Amount";
      setLoading(true);
      setLoadingText("Getting Amount, please wait...");

      const formatTime = (date) =>
        date instanceof Date
          ? `${date.getHours().toString().padStart(2, "0")}${date
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : date || "";

      const toDate = (time) => {
        if (!time) return null;

        if (time instanceof Date) return time;

        const [h, m] = time.split(":").map(Number);
        return new Date(2000, 0, 1, h, m);
      };

      const getTimeDiff = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "0";

        let diff = endDate - startDate;
        if (diff < 0) {
            diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return minutes > 0 ? hours + 1 : hours;
      };
      
      const getActualDuration = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "00:00";

        let diff = endDate - startDate;
        if (diff < 0) {
          diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
        const mm = String(totalMinutes % 60).padStart(2, "0");

        return `${hh}:${mm}`;
      };
  
      const deptId = userDept.key;
      const DayType = dayType.key;
      const WorkLocation = workLocation.key;
      const AllowanceType = allowanceType.key;
      const StartTime = formatTime(startTime);
      const EndTime = formatTime(endTime);
      const totalTime = getTimeDiff(startTime, endTime);
      const actualDuration = getActualDuration(startTime, endTime);
      setTotalHour(actualDuration);

      http
        .get("api/allowance/GetAmount?_sysUser=" + userId +
          "&_deptId=" +
          deptId +
          "&_dayType=" +
          DayType +
          "&_workLocation=" +
          WorkLocation +
          "&_allowanceType=" +
          AllowanceType +
          "&_startTime=" +
          StartTime +
          "&_endTime=" +
          EndTime +
          "&_totalTime=" +
          totalTime, { timeout: 10000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].ALLOWANCE_RATE_MST_ID,
              value: response.data[i].AMOUNT,
              label: response.data[i].REMARK,
              HOUR_FROM: response.data[i].HOUR_FROM,
              HOUR_TO: response.data[i].HOUR_TO,
            });

            const item = response.data[i];

            const timeToDate = (time) => {
              if (!time || time === 'N/A') return null;

              if (/^\d{4}$/.test(time)) {
                const h = Number(time.slice(0, 2));
                const m = Number(time.slice(2, 4));
                return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
              }

              if (/^\d{2}:\d{2}$/.test(time)) {
                const [h, m] = time.split(':').map(Number);
                return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
              }

              if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
                const [h, m] = time.split(':').map(Number);
                return isNaN(h) || isNaN(m) ? null : new Date(2000, 0, 1, h, m);
              }

              return null;
            };

            const isSameTimeRange = (a, b) =>
              a?.[0]?.getTime?.() === b?.[0]?.getTime?.() &&
              a?.[1]?.getTime?.() === b?.[1]?.getTime?.();

            if(AllowanceType == '459E6A7E-289A-4EB5-B99C-DEE6D6D15153') {
              if (timeToDate(item.HOUR_FROM) && timeToDate(item.HOUR_TO)) {
                setTimeRange(prev =>
                  isSameTimeRange(
                    prev,
                    [timeToDate(item.HOUR_FROM), timeToDate(item.HOUR_TO)]
                  )
                    ? prev
                    : [timeToDate(item.HOUR_FROM), timeToDate(item.HOUR_TO)]
                );
              }
              setIsFixedTime(true);
            } else if (item.HOUR_FROM == 'N/A' && item.HOUR_TO == 'N/A') {
              setIsFixedTime(true);
            } else {
              setIsFixedTime(false);
            }
          }
          setAmount(listItems[0]);
        })
        .catch((err) => {
          toast.error("Error on getting amount. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting amount. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId, userDept, dayType, workLocation, allowanceType, startTime, endTime]);
  // #endregion 

  // #region OnClick
  const AddBtnOnClick = () => {
    let functionName = "";
  
    try {
      functionName = PAGE_NAME + AddBtnOnClick.name;
      setLoading(true);
      setLoadingText("Adding Allowance Claim, Please wait...");

      const StartTime = startTime || "00:00";
      const EndTime = endTime || "00:00";

      const toDate = (time) => {
        if (!time) return null;

        if (time instanceof Date) return time;

        const [h, m] = time.split(":").map(Number);
        return new Date(2000, 0, 1, h, m);
      };

      const getTimeDiff = (start, end) => {
        const startDate = toDate(start);
        const endDate = toDate(end);

        if (!startDate || !endDate) return "00:00";

        let diff = endDate - startDate;
        if (diff < 0) {
            diff += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.round(diff / (1000 * 60));
        const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
        const mm = String(totalMinutes % 60).padStart(2, "0");

        return `${hh}:${mm}`;
      };

      const totalTime = getTimeDiff(StartTime, EndTime);

      const combineDateTime = (dateStr, time) => {
        if (!dateStr || !time) return "";

        const [year, month, day] = dateStr.split("-");

        let h, m;
        if (time instanceof Date) {
          h = time.getHours();
          m = time.getMinutes();
        } else {
          [h, m] = time.split(":").map(Number);
        }

        const hour = String(h).padStart(2, "0");
        const minute = String(m).padStart(2, "0");

        return `${year}-${month}-${day} ${hour}:${minute}:00`;
      };

      const formatTime = (date) =>
        date instanceof Date
          ? `${date.getHours().toString().padStart(2, "0")}:${date
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          : date || "";

      const datetimeFrom = combineDateTime(editData.DATE, StartTime);
      const datetimeTo = combineDateTime(editData.DATE, EndTime);
      const totalClaim = totalAmount + parseFloat(amount.value);

      const data = {
        ALLOWANCE_MST_ID: allowanceId || "", //get from allData
        USER_MST_GUID: userId,
        TOTAL_CLAIM: totalClaim,
        UPDATE_ID: userId,
        UPDATE_NAME: userName,
        DAY_TYPE: dayType.key,
        WORK_LOCATION: workLocation.key,
        ALLOWANCE_TYPE: allowanceType.key,
        DATETIME_FROM: datetimeFrom,
        DATETIME_TO: datetimeTo,
        AMOUNT: parseFloat(amount.value).toFixed(2),
        PURPOSE: editData.PURPOSE,
        DETAILS: editData.DETAILS,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID }
      };

      http.post("api/allowance/AddAllowance", data, { timeout: 10000 })
      .then((response) => {
        const returnAllowanceId = response.data?.ALLOWANCE_MST_ID;
        const returnAllowanceDetailsId = response.data?.ALLOWANCE_DETAILS_ID;
        if (returnAllowanceId) {
          setAllowanceId(returnAllowanceId);
        }

        const newRow = {
          ALLOWANCE_MST_ID: returnAllowanceId || "",
          ALLOWANCE_DETAILS_ID: returnAllowanceDetailsId || "",
          DATE: editData.DATE,
          DAY_TYPE_ID: dayType.key,
          DAY_TYPE: dayType.label,
          WORK_LOCATION_ID: workLocation.key,
          WORK_LOCATION: workLocation.label,
          ALLOWANCE_TYPE_ID: allowanceType.key,
          ALLOWANCE_TYPE: allowanceType.label,
          START_TIME: formatTime(StartTime),
          END_TIME: formatTime(EndTime),
          TOTAL_HOURS: totalTime,
          AMOUNT: parseFloat(amount.value).toFixed(2),
          PURPOSE: editData.PURPOSE,
          DETAILS: editData.DETAILS,
        };
        
        setAllData((prev) => [...prev, newRow]);
        toast.success("Allowance is successfully added.");
        hideFields();
      })
      .catch((err) => {
        const errorData = err.response?.data || {};
        if(errorData.VALID === "DATE_CLAIM_DUPLICATE") {
          toast.error(errorData.ERROR_MSG);
          common.c_LogWebError(PAGE_NAME, functionName, err);
        } else {
          console.error("Error response:", err.response); 
          toast.error("Failed to apply allowance. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      })
      .finally(() => {
        setLoading(false);
        setLoadingText("Loading...");
      });
    } catch (err) {
      toast.error("Failed to add allowance. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
      setLoading(false);
      setLoadingText("Loading...");
    }
  }
  // endregion

  function ApplyAllowance() {
    let functionName = "";
  
    try {
      functionName = PAGE_NAME + ApplyAllowance.name;
      setLoading(true);
      setLoadingText("Applying Allowance, Please wait...");

      const data = {
        ALLOWANCE_MST_ID: allowanceId,
        USER_MST_GUID: userId,
        TOTAL_CLAIM: totalAmount,
        UPDATE_ID: userId,
        UPDATE_NAME: userName,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID }
      };
  
      // Proceed with the API call if dataSend is not empty
      http.post("api/allowance/ApplyAllowance", data, { timeout: 10000 })
      .then((response) => {
        toast.success("Allowance is successfully applied.");
        
        setTimeout(() => {
          navigate("/AllowanceHistory");
        }, 500);
      })
      .catch((err) => {
        console.error("Error response:", err.response); 
        toast.error("Failed to apply allowance. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      })
      .finally(() => {
        setLoading(false);
        setLoadingText("Loading...");
      });
    } catch (err) {
      console.error("Error response 1:", err.response); 
      toast.error("Failed to apply allowance. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
      setLoading(false);
      setLoadingText("Loading...");
    }
  }

  //#region HANDLER
  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: `${name} could not be empty.`,
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));

      if (id === "DATE" && val) {
        const selectedDate = new Date(val + "T00:00:00");

        const dayOfWeek = selectedDate.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        const isHoliday = holidayList.some(
          (h) => new Date(h.value).toDateString() === selectedDate.toDateString()
        );

        let newDayType = null;

        if (isWeekend || isHoliday) {
          newDayType = dayTypeList.find(
            (dt) => dt.value === "7B396124-52B2-4EB1-9A85-4F294B7911EB"
          );
        } else {
          newDayType = dayTypeList.find(
            (dt) => dt.value === "2A1138EA-1C4D-45A2-BE70-A1F123AC01DF"
          );
        }

        if (newDayType) {
          setDayType({ key: newDayType.key, value: newDayType.value, label: newDayType.label });
        }

        setWorkLocation("");
        setAllowanceType("");
        setTimeRange([null, null]);
        setIsFixedTime(false);
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  
  const selectDayTypeHandler = (val) => {
    let functionName = "";
  
    try {
      functionName = selectDayTypeHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          DAY_TYPE: "",
          AMOUNT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          DAY_TYPE: "Day Type could not be empty.",
        }));
      }
      setDayType(val);
      setWorkLocation("");
      setAllowanceType("");
      setTimeRange([null, null]);
      setIsFixedTime(false);
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  
  const selectWorkLocationHandler = (val) => {
    let functionName = "";
  
    try {
      functionName = selectWorkLocationHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          WORK_LOCATION: "",
          AMOUNT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          WORK_LOCATION: "Work Location could not be empty.",
        }));
      }
      setWorkLocation(val);
      setAllowanceType("");
      setTimeRange([null, null]);
      setIsFixedTime(false);
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  
  const selectAllowanceTypeHandler = (val) => {
    let functionName = "";
  
    try {
      functionName = selectAllowanceTypeHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          ALLOWANCE_TYPE: "",
          AMOUNT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          ALLOWANCE_TYPE: "Allowance Type could not be empty.",
        }));
      }
      setAllowanceType(val);
      setTimeRange([null, null]);
      setIsFixedTime(false);
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  
	const handleTimeChange = times => {
    const [start, end] = times;

    setInputError((prevState) => ({
      ...prevState,
      TIME: (""),
      AMOUNT: "",
    }));

    // if (start && end) {
    //   const timeToMinutes = (t) => t.getHours() * 60 + t.getMinutes();

    //   if (timeToMinutes(end) < timeToMinutes(start)) {
    //     setInputError((prev) => ({
    //       ...prev,
    //       TIME: "End time cannot be earlier than start time",
    //     }));
    //     return;
    //   }
    // }
    setTimeRange(times);
  }

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onReloadHandler = (deletedRow, detailsCount) => {
    setReload(!reload);

    if (!deletedRow) return;

    setAllData((prev) =>
      prev.filter(
        (x) => x.ALLOWANCE_DETAILS_ID !== deletedRow.ALLOWANCE_DETAILS_ID
      )
    );
    
    if (detailsCount == 0) {
      setAllowanceId("");
    }
  };

  const showUpdateModal = (e, row) => {
    setShowUpdate(!showUpdate);
    setUpdateData(row);
  };

  const hideUpdateModal = () => {
    setShowUpdate(!showUpdate);
    setUpdateData(null);
  };
  
  const handleUpdateRow = (updatedRow) => {
    setAllData((prev) =>
      prev.map((row) =>
        row.ALLOWANCE_DETAILS_ID === updatedRow.ALLOWANCE_DETAILS_ID
          ? updatedRow
          : row
      )
    );
  };

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setUpdateData(row);
  };

  const hideDeleteModal = () => {
    setShowDelete(false);
    setUpdateData(null);
  };

  const handleAdd = () => {
    var flag = true;

    if (dayType.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DAY_TYPE: ("Day Type could not be empty."),
			}));
		}

    if (workLocation.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				WORK_LOCATION: ("Work Location could not be empty."),
			}));
		}

    if (allowanceType.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				ALLOWANCE_TYPE: ("Allowance Type could not be empty."),
			}));
		}

    if (editData.DATE === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DATE: ("Date could not be empty."),
			}));
		// } else {
    //   const selectedDate = new Date(editData.DATE);
    //   const day = selectedDate.getDay();
    //   const formattedDate = `${selectedDate.getDate().toString().padStart(2,'0')}/${
    //     (selectedDate.getMonth()+1).toString().padStart(2,'0')}/${
    //     selectedDate.getFullYear()}`;

    //   if (dayType.key === "2A1138EA-1C4D-45A2-BE70-A1F123AC01DF" && (day === 0 || day === 6)) {
    //     flag = false;
    //     setInputError((prevState) => ({
    //       ...prevState,
    //       DATE: (formattedDate + " is not " + dayType.label),
    //     }));
    //   } else if (dayType.key === "7B396124-52B2-4EB1-9A85-4F294B7911EB" && (day !== 0 && day !== 6)) {
    //     flag = false;
    //     setInputError((prevState) => ({
    //       ...prevState,
    //       DATE: (formattedDate + " is not " + dayType.label),
    //     }));
    //   }
    }

    // if (startTime === null || endTime === null) {
    //   flag = false;
		// 	setInputError((prevState) => ({
		// 		...prevState,
		// 		TIME: ("Time could not be empty."),
		// 	}));
		// }

    if (!amount || amount.value == "0") {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				AMOUNT: ("Amount could not be 0."),
			}));
		}

    if (editData.PURPOSE === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				PURPOSE: ("Purpose could not be empty."),
			}));
		}

    if (editData.DETAILS === undefined) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				DETAILS: ("Details could not be empty."),
			}));
		}

    if (flag) {
      AddBtnOnClick();
    } else {
      return;
    }
  }

  const hideFields = () => {
    setDayType([]);
    setWorkLocation([]);
    setAllowanceType([]);
    setTimeRange([null, null]);
    setEditData(initialEditData);
    setAmount([]);
  };

  const handleConfirm = () => {
    let flag = true;
    let errors = {};

    if (allData.length === 0) {
      flag = false;
      errors["allData"] = "Table cannot be empty.";
      toast.error("Table cannot be empty.");
    }

    setInputError(errors);

    if (Object.keys(errors).length === 0 && flag) {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    ApplyAllowance();
    setShowConfirmModal(false); // Hide confirm modal
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };

  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span className="text-lg font-semibold" style={{ fontSize: '18px' }}>Total Claimed</span>
          <span className="text-lg font-semibold" style={{ fontSize: '18px', fontWeight: 'bold' }}>
            RM {totalAmount === 0 ? "0" : totalAmount.toFixed(2)}
          </span>
        </div>
        
        <div style={{
          width: '2px',
          backgroundColor: '#ccc',
          height: '3.2rem',
          margin: '0 15px'
        }}></div>

        <Tag 
          icon="pi pi-exclamation-triangle" 
          severity="warning" 
          value="Pending" 
          style={{ fontSize: '14px', padding: '0 0.6rem', height: '40px', display: 'flex', alignItems: 'center' }}
        />
      </div>
    );
  };

  return (
    <>
      <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo} allowanceTableWrapper`}>
          <table className="allowanceTable">
            <tr>
              <td colSpan="2" style={{ paddingRight: "1rem" }}>
                <Comp.Input
                  id="DATE"
                  label="Date*"
                  type="date"
                  name="Date"
                  value={editData.DATE || ""}
                  placeholderText="Select date"
                  onChange={inputRequiredHandler}
                  errorMessage={inputError.DATE}
                />
              </td>
              <td colSpan="2" style={{ paddingRight: "1rem" }}>
                <Comp.Select
                  id="WORK_LOCATION"
                  label="Work Location*"
                  type="text"
                  name="Work Location"
                  options={workLocationList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  value={workLocation}
                  onChange={selectWorkLocationHandler}
                  errorMessage={inputError.WORK_LOCATION}
                  isMulti={false}
                />
              </td>
              <td colSpan="2" style={{ paddingRight: "1rem" }}>
                <Comp.Select
                  id="ALLOWANCE_TYPE"
                  label="Allowance Type*"
                  type="text"
                  name="Allowance Type"
                  options={allowanceTypeList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  value={allowanceType}
                  onChange={selectAllowanceTypeHandler}
                  errorMessage={inputError.ALLOWANCE_TYPE}
                  isMulti={false}
                />
              </td>
              <td colSpan="2" style={{ paddingRight: "1rem" }}>
                <Comp.TimeRangePicker
                  id="TIME"
                  label="Time (From - To)"
                  name="Time"
                  value={timeRange}
                  onChange={handleTimeChange}
                  disabled={isFixedTime}
                />
              </td>
              <td colSpan="2" style={{ paddingRight: "1rem" }}>
                <Comp.Input
                  id="TOTAL_TIME"
                  label="Total Time (hh:mm)"
                  name="Total Time"
                  value={totalHour}
                  readOnly
                />
              </td>
              <td colSpan="2">
                <Comp.Input
                  id="AMOUNT"
                  label="Amount"
                  type="text"
                  name="Amount"
                  className="form-control-amount"
                  value={`RM ${amount?.value ? amount.value.toFixed(2) : 0}`}
                  errorMessage={inputError.AMOUNT}
                  readOnly
                />
              </td>
            </tr>
            <tr>
              <td colSpan="4" style={{ paddingRight: "1rem" }}>
                <label style={{ padding: "6px" }}>Purpose*</label>
                <textarea
                  id="PURPOSE"
                  name="Purpose"
                  rows={2}
                  className="form-control-allowance"
                  value={editData.PURPOSE}
                  onChange={inputRequiredHandler}
                />
                {inputError.PURPOSE && (
                  <div className="text-danger mt-1">
                    {inputError.PURPOSE}
                  </div>
                )}
              </td>
              <td colSpan="4" style={{ paddingRight: "1rem" }}>
                <label style={{ padding: "6px" }}>Details*</label>
                <textarea
                  id="DETAILS"
                  name="Details"
                  rows={2}
                  className="form-control-allowance"
                  value={editData.DETAILS}
                  onChange={inputRequiredHandler}
                />
                {inputError.DETAILS && (
                  <div className="text-danger mt-1">
                    {inputError.DETAILS}
                  </div>
                )}
              </td>
              <td colSpan="4">
                <label style={{ padding: "6px" }}>Remark</label>
                <textarea
                  id="REMARK"
                  name="Remark"
                  rows={2}
                  className="form-control-allowance"
                  value={amount?.label || ""}
                  readOnly
                />
              </td>
            </tr>
            <tr>
              <td colSpan="12"  style={{ padding: "0.5rem 1rem 0.5rem 0" }}>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <Comp.Button
                    id="btnAdd"
                    type="submit"
                    onClick={handleAdd}
                  >
                  <FontAwesomeIcon icon={faSquarePlus} />  ADD  
                  </Comp.Button>
                  <Comp.Button 
                    id="btnSubmit" 
                    type="submit"
                    onClick={handleConfirm}
                    onLoading={onLoadingHandler}
                  >
                    Submit  <FontAwesomeIcon icon={faFileImport} />
                  </Comp.Button>
                </div>
              </td>
            </tr>
          </table>
      </div>

      <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
        <div style={{width: '100%'}}>
          <DataTable value={allData} dataKey="ALLOWANCE_MST_ID" header={renderHeader()} 
            loading={loading} removableSort emptyMessage="Fill in and add to allowance claim."
            scrollable scrollHeight="700px" showGridlines className="datatable" tableStyle={{ minWidth: '120rem' }}
          >
            <Column
              header="Action"
              body={(rowData) => (
                <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  <span title="Modify">
                    <Comp.Button
                      id="btnEdit"
                      type="general"
                      onClick={(e) => showUpdateModal(e, rowData)}
                      style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </Comp.Button>
                  </span>
                  <span title="Delete">
                    <Comp.Button
                      id="btnDelete"
                      type="delete"
                      onClick={() => showDeleteModal(rowData)}
                      style={{ width: "50px", height: "35px" }}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </Comp.Button>
                  </span>
                </div>
              )}
              style={{
                width: '90px'
              }}
            />
            <Column
              header="#"
              body={(rowData, options) => options.rowIndex + 1}
              style={{ width: '2.5rem', textAlign: 'center' }}
            />
            <Column field="DATE" 
              header="Date" 
              style={{ textAlign: "center" }}
              body={(rowData) => {
                if (!rowData.DATE) return "";

                const d = new Date(rowData.DATE);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();

                return `${day}/${month}/${year}`;
              }}
            />
            <Column field="DAY_TYPE" header="Day Type" style={{ textAlign: "center" }}></Column>
            <Column field="WORK_LOCATION" header="Work Location" style={{ textAlign: "center" }}></Column>
            <Column field="ALLOWANCE_TYPE" header="Allowance Type" style={{ textAlign: "center" }}></Column>
            <Column field="START_TIME" header="Start Time" style={{ textAlign: "center" }} bodyStyle={{ backgroundColor: "#e1f2fb" }}></Column>
            <Column field="END_TIME" header="End Time" style={{ textAlign: "center" }} bodyStyle={{ backgroundColor: "#e1f2fb" }}></Column>
            <Column field="TOTAL_HOURS" header="Total Working Hours (hh:mm)" style={{ textAlign: "center" }} bodyStyle={{ backgroundColor: "#e1f2fb" }}></Column>
            <Column field="PURPOSE" header="Purpose" style={{ textAlign: "left", minWidth: "200px" }}></Column>
            <Column field="DETAILS" header="Details" style={{ textAlign: "left", minWidth: "200px" }}></Column>
            <Column field="AMOUNT" header="Amount (RM)" style={{ textAlign: "right" }} bodyStyle={{ backgroundColor: "#ebf5eb", fontWeight: "bold" }}></Column>
          </DataTable>
        </div>
      </div>

      {/* Confirm Modal */}
      <AllowanceDetailsUpdate
        page={props.page}
        module={MODULE_ID}
        showHide={showUpdate}
        editData={updateData}
        onHide={hideUpdateModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
        onUpdateRow={handleUpdateRow}
      />

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
        prop="Confirm to apply"
      >
        Are you sure you want to apply this allowance?
      </ConfirmModal>

      {showDelete && (
        <AllowanceDetailsDelete
          page={props.page}
          module={MODULE_ID}
          showHide={showDelete}
          editData={updateData}
          onHide={hideDeleteModal}
          onReload={onReloadHandler}
          onLoading={onLoadingHandler}
        />
      )}

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
}

export default Allowance;
